import { withShowIf } from "../../with-show-if/with-show-If.component";
import React from "react";
import { TitleStyled } from "./title.styles";

export const Title = withShowIf((props: any) => <TitleStyled {...props} />);
